<template>
  <div class="ww_about_index">
    <img src="@/assets/wwabout/1.png" alt="">
    <img src="@/assets/wwabout/2.png" alt="">
    <img src="@/assets/wwabout/3.png" alt="">
    <img src="@/assets/wwabout/4.png" alt="">
    <img src="@/assets/wwabout/5.png" alt="">
    <img src="@/assets/wwabout/6.png" alt="">
    <img src="@/assets/wwabout/7.png" alt="">
    <img src="@/assets/wwabout/8.png" alt="">
    <img src="@/assets/wwabout/9.png" alt="">
    <img src="@/assets/wwabout/10.png" alt="">
  </div>  
</template>
<script>
export default {
  data(){
    return {
      img:''
    }
  },
  created(){
    this.$loading.hide();
  }
}
</script>
<style lang="less" scoped>
  .ww_about_index{
    img{
      max-width: 100%;
      display: block;
    }
  }
</style>